__turbopack_context__.v({
  "ApplyNow_Custom": "NavWithScroll-module-scss-module__T_XPzq__ApplyNow_Custom",
  "NavWithScroll__cardContainer": "NavWithScroll-module-scss-module__T_XPzq__NavWithScroll__cardContainer",
  "NavWithScroll__listContainer": "NavWithScroll-module-scss-module__T_XPzq__NavWithScroll__listContainer",
  "NavWithScroll__selectedLink": "NavWithScroll-module-scss-module__T_XPzq__NavWithScroll__selectedLink",
});
